import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { getobj, updateobj } from "../../apicall/apicall";
import EditIcon from "@mui/icons-material/Edit";
import { NotificationManager } from "react-notifications";
import NotificationContainer from "react-notifications/lib/NotificationContainer";
import Cookies from "js-cookie";

//import { TextField } from "@mui/material";

import { textfield } from "../../style/style";

export default function Profile(props) {
  const [refreshed, setrefresh] = useState(false);
  const [checked, setcheck] = useState();
  const [basic, setbasic] = useState();
  const [loaded, setloaded] = useState(true);
  const [newVal, setnewVal] = useState({ id: props.id });
  const [customerinfo, setcustomerinfo] = useState(false);
  const [updateemailDialogue, setupdateemaildialogue] = useState(false);
  const [otp, setotp] = useState();
  const [matched, setmatched] = useState();

  const loc = useLocation();
  useEffect(() => {
    const url =
      process.env.REACT_APP_ZEWA_URL + "user/get-customer/" + props.id + "/";
    const d = getobj(url);
    d.then(function (res) {
      setbasic(res.data);
      setcheck(res.data.data_forwarding_status);
      setloaded(false);
    });
  }, [props.id, refreshed]);
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   //console.log(e.target.name);
  //   if (loc.pathname === "/admin") {
  //     if (name === "status") {
  //       setcheck(e.target.checked);

  //       updateProfile({
  //         id: props.id,
  //         data_forwarding_status: e.target.checked,
  //       });
  //     } else if (name === "data_forwarding_url") {
  //       seturl({ id: props.id, data_forwarding_url: value });
  //     } else if (name === "logo") {
  //       seturl({ id: props.id, logo: e.target.files[0] });
  //     }
  //   } else if (loc.pathname === "/customer") {
  //     if (name === "status") {
  //       setcheck(e.target.checked);
  //       updateProfile({ data_forwarding_status: e.target.checked });
  //     } else if (name === "data_forwarding_url") {
  //       seturl({ data_forwarding_url: value });
  //     } else if (name === "logo") {
  //       seturl({ logo: e.target.files[0] });
  //     }
  //   }
  // };

  const updateCustomerInfo = () => {
    // console.log(newVal)
    const url =
      process.env.REACT_APP_ZEWA_URL + "user/update/" + newVal["id"] + "/";
    const res = updateobj(url, newVal);
    res.then(function (res) {
      // console.log(res);
      setrefresh(!refreshed);
    });
  };

  const handleNewChange = (e) => {
    const { name, value } = e.target;
    setnewVal({
      ...newVal,
      [name]: value,
    });
  };

  // const handleClose = () => {
  //   setopen({
  //     name: "",
  //     value: false,
  //   });
  // };
  // const uploadlogo = async (data) => {
  //   // console.log(data);
  //   const url = process.env.REACT_APP_ZEWA_URL + "user/customer-profile/";
  //   const uploadData = new FormData();
  //   uploadData.append("id", data.id);
  //   uploadData.append("logo", data.logo);

  //   await fetch(url, {
  //     headers: {
  //       Authorization: "Token " + sessionStorage.getItem("token"),
  //       "X-CSRFToken": Cookies.get("csrftoken"),
  //     },
  //     method: "PATCH",
  //     body: uploadData,
  //   })
  //     .then((res) => {
  //       // console.log(res);
  //       setopen({
  //         name: "",
  //         value: false,
  //       });
  //       setrefresh(!refreshed);
  //       if (loc.pathname === "/customer") {
  //         customerContest.setmanage({
  //           ...manage,
  //           refresh: !manage.refresh,
  //         });
  //       }
  //     })
  //     .catch((err) => console.log(err));
  // };
  // const updateProfile = (data) => {
  //   // console.log(data);

  //   const url = process.env.REACT_APP_ZEWA_URL + "user/customer-profile/";
  //   const res = updateobj(url, data);
  //   res.then(function (d) {
  //     // console.log(d);
  //     setopen({
  //       name: "",
  //       value: false,
  //     });

  //     setrefresh(!refreshed);
  //   });
  // };
  return (
    <div>
      {loaded ? (
        <img
          src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif"
          alt="loading..."
        />
      ) : (
        <Box>
          {basic && (
            <TableContainer>
              <Table
                sx={{ minWidth: 650 }}
                size="small"
                aria-label="a dense table"
              >
                <TableBody>
                  <TableRow>
                    <TableCell> Company Name:</TableCell>{" "}
                    <TableCell>{basic.company_name}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell> Name</TableCell>
                    <TableCell>
                      {basic.customer_first_name +
                        " " +
                        basic.customer_last_name}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell> Email</TableCell>{" "}
                    <TableCell>{basic.customer_email}</TableCell>
                    <TableCell>
                      <EditIcon
                        sx={{ color: "blue" }}
                        onClick={() => setupdateemaildialogue(true)}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell> Phone:</TableCell>{" "}
                    <TableCell>{basic.customer_phone_number}</TableCell>
                    <TableCell>
                      <EditIcon
                        sx={{ color: "blue" }}
                        onClick={() => setcustomerinfo(true)}
                      />
                    </TableCell>
                  </TableRow>

                  {/* <TableRow>
                  <TableCell> Company Address:</TableCell>{" "}
                  <TableCell>
                    {basic.company_address}, {basic.zip_code}
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow> */}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      )}
      <Dialog open={customerinfo} onClose={() => setcustomerinfo(false)}>
        <DialogTitle>Update Profile</DialogTitle>

        <TextField
          id="outlined-basic"
          name="first_name"
          label="Enter First Name"
          defaultValue={basic && basic.customer_first_name}
          variant="outlined"
          sx={textfield}
          onChange={handleNewChange}
        />
        <TextField
          id="outlined-basic"
          label="Enter Last Name"
          defaultValue={basic && basic.customer_last_name}
          name="last_name"
          variant="outlined"
          sx={textfield}
          onChange={handleNewChange}
        />
        <TextField
          id="outlined-basic"
          label="Enter Phone Number"
          defaultValue={basic && basic.customer_phone_number}
          name="phone_number"
          variant="outlined"
          sx={textfield}
          onChange={handleNewChange}
        />

        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => setcustomerinfo(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              //console.log("clicked");
              setcustomerinfo(false);
              updateCustomerInfo(newVal);
            }}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={updateemailDialogue}
        onClose={() => setupdateemaildialogue(false)}
      >
        <DialogTitle>Update Profile</DialogTitle>

        <TextField
          id="outlined-basic"
          name="email"
          label="Enter Email"
          defaultValue={basic && basic.customer_email}
          variant="outlined"
          sx={textfield}
          onChange={handleNewChange}
          disabled={otp ? true : false}
        />
        {otp && (
          <>
            <div
              style={{
                marginTop: "10px",
                marginBottom: "10px",
                fontSize: "14px",
                color: "#1976d2",
              }}
            >
              OTP has been sent to your new email address. Please enter it below
              to verify.
            </div>
            <TextField
              id="outlined-otp"
              name="otp"
              label="Enter OTP"
              placeholder="6-digit OTP"
              variant="outlined"
              sx={textfield}
              value={matched || ""}
              onChange={(e) => {
                setmatched(e.target.value);
              }}
              autoFocus
            />
          </>
        )}

        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              setupdateemaildialogue(false);
              setotp(null);
              setmatched(null);
              setnewVal({ id: props.id });
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              if (!newVal.email || newVal.email === basic.customer_email) {
                NotificationManager.error(
                  "Please enter a new email address",
                  "Error",
                  2000,
                );
                return;
              }

              if (otp) {
                if (!matched) {
                  NotificationManager.error(
                    "Please enter the OTP",
                    "Error",
                    2000,
                  );
                  return;
                }

                // Send OTP to backend for verification
                const url =
                  process.env.REACT_APP_ZEWA_URL +
                  "user/update/" +
                  newVal["id"] +
                  "/?email=true&otp=true";

                // Send the OTP along with email for verification
                const verificationData = {
                  ...newVal,
                  otp: matched,
                };

                const res = updateobj(url, verificationData);
                res
                  .then((response) => {
                    console.log("OTP Verification Response:", response);
                    if (response?.status === 200 || response?.Message) {
                      setotp(null);
                      setmatched(null);
                      setnewVal({ id: props.id });
                      NotificationManager.remove(
                        NotificationManager.listNotify[0],
                      );

                      NotificationManager.success(
                        response?.Message || "Email updated successfully",
                      );
                      setrefresh(!refreshed);
                      setupdateemaildialogue(false);
                    } else {
                      throw new Error(response);
                    }
                  })
                  .catch((err) => {
                    NotificationManager.remove(
                      NotificationManager.listNotify[0],
                    );

                    NotificationManager.error(
                      err?.Message ||
                        "OTP verification failed. Please enter the correct OTP.",
                      "Failed",
                      2000,
                    );
                  });
              } else {
                const url =
                  process.env.REACT_APP_ZEWA_URL +
                  "user/update/" +
                  newVal["id"] +
                  "/?email=true";
                const res = updateobj(url, newVal);
                res
                  .then((response) => {
                    console.log("OTP Send Response:", response);

                    // Backend sends OTP to email and confirms with status 200
                    // We don't need to extract OTP - just show the input field
                    if (response?.status === 200 || response?.message) {
                      // Set otp to true (as a flag, not the actual OTP)
                      setotp(true);
                      NotificationManager.success(
                        "OTP sent to your new email address",
                        "Success",
                        2000,
                      );
                    } else {
                      throw new Error(response);
                    }
                  })
                  .catch((err) => {
                    console.error("OTP Send Error:", err);
                    NotificationManager.error(
                      err?.Message ||
                        "Failed to send OTP. Please check your email address.",
                      "Error",
                      2000,
                    );
                  });
              }
            }}
          >
            {otp ? "Verify OTP" : "Send OTP"}
          </Button>
        </DialogActions>
      </Dialog>
      <NotificationContainer />
    </div>
  );
}
